/**
 * 2007-2016 PrestaShop
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.txt.
 * It is also available through the world-wide-web at this URL:
 * http://opensource.org/licenses/osl-3.0.php
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to http://www.prestashop.com for more information.
 *
 * @author    PrestaShop SA <contact@prestashop.com>
 * @copyright 2007-2016 PrestaShop SA
 * @license   http://opensource.org/licenses/osl-3.0.php Open Software License (OSL 3.0)
 * International Registered Trademark & Property of PrestaShop SA
 */
import $ from 'expose?$!expose?jQuery!jquery';
import 'expose?Tether!tether';
import 'bootstrap/dist/js/bootstrap.min';
import 'bootstrap-touchspin';

import '../css/theme';
import './responsive';
import './checkout';
import './customer';
import './listing';
import './product';
import './cart';

import DropDown from './components/drop-down';
import Form from './components/form';
import MainMenu from './components/main-menu';
// import ProductMinitature from './components/product-miniature';
import ProductSelect from './components/product-select';

import prestashop from 'prestashop';
import EventEmitter from 'events';

import './lib/bootstrap-filestyle.min';
import './lib/jquery.bxslider.min';
import './lib/jquery.cookie';

import './components/block-cart';

// "inherit" EventEmitter
for (var i in EventEmitter.prototype) {
  prestashop[i] = EventEmitter.prototype[i];
}

$(document).ready(() => {
  let dropDownEl = $('.js-dropdown');
  const form = new Form();
  let dropDown = new DropDown(dropDownEl);
  // let productMinitature = new ProductMinitature();
  let productSelect  = new ProductSelect();
  let mainMenu = new MainMenu();
  dropDown.init();
  form.init();
  mainMenu.init();
  // productMinitature.init();
  productSelect.init();
  /*$("#products").bind("DOMSubtreeModified", function() {
    productMinitature.init();
  });*/

  // carousel product page
  if (!!$.prototype.bxSlider)
    $('.page-product #main .jq_carousel, .cross-selling .jq_carousel').bxSlider({
      minSlides: 1,
      maxSlides: 10,
      slideWidth: 180,
      slideMargin: 15,
      pager: false,
      nextText: '',
      prevText: '',
      moveSlides:1,
      infiniteLoop:false,
      hideControlOnEnd: true
    });
  
  // carouel columns (vertical), in sidebar
  if (!!$.prototype.bxSlider) {
    $('.sidebar .jq_carousel').bxSlider({
      mode: 'vertical',
      slideMargin: 0,
      moveSlides:1,
      pager: false,
      auto: true,
      useCSS: false
    });
  }

  // Back to top
  if($(window).width()>600) {
    $('body').prepend('<div id="toTop">Top</div>');

    $(window).scroll(function() {
      if($(this).scrollTop() != 0) {
        $('#toTop').fadeIn();
      } else {
        $('#toTop').fadeOut();
      }
    });

    $('#toTop').click(function() {
      $('body,html').animate({scrollTop:0},800);
    });
  };

  NbCols();

  $(window).resize(function() {
    NbCols();
  });
});

var NbCols = function () {
  // count columns in content column
  jQuery('#content-wrapper').attr('data-nb-cols', Math.floor((jQuery('#content-wrapper').width() + 15) / 195));

  // count columns in footer
  jQuery('.footer-container > .container:first-child').attr('data-nb-cols', Math.floor((jQuery('.footer-container > .container:first-child').width() + 15) / 195));
}



// WEBPACK FOOTER //
// ./js/theme.js